export default function Privacy() {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-ef277cf elementor-section-full_width elementor-section-height-default elementor-section-height-default"
      data-id="ef277cf"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b3a881d"
          data-id="b3a881d"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-b1f9e7d elementor-widget elementor-widget-heading"
              data-id="b1f9e7d"
              data-element_type="widget"
              data-widget_type="heading.default"
            >
              <div className="elementor-widget-container">
                <h3 className="elementor-heading-title elementor-size-default">
                  Privacy & Data Protection
                </h3>
              </div>
            </div>
            <div
              className="elementor-element elementor-element-c19b938 elementor-widget elementor-widget-text-editor"
              data-id="c19b938"
              data-element_type="widget"
              data-widget_type="text-editor.default"
            >
              <div className="elementor-widget-container"></div>
            </div>
          </div>
        </div>
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-ec74693"
          data-id="ec74693"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-1955ec6 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="1955ec6"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-910c56c"
                  data-id="910c56c"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-08b0370 elementor-widget elementor-widget-heading"
                      data-id="08b0370"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          General Data Protection Regulation (GDPR)
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-86c44e3 elementor-widget elementor-widget-text-editor"
                      data-id="86c44e3"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          The General Data Protection Regulation has been
                          created to protect personal information and the
                          privacy of EU and UK-based individuals
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-aff6144"
                  data-id="aff6144"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-493ef6c elementor-widget elementor-widget-heading"
                      data-id="493ef6c"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Health Insurance Portability and Accountability Act
                          (HIPAA)
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-e757600 elementor-widget elementor-widget-text-editor"
                      data-id="e757600"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Made to ensure that if your company can procure and
                          store protected health information, it follows the
                          best practices to store sensitive data
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-dff3cbe elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="dff3cbe"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-7fb3c4f"
                  data-id="7fb3c4f"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-d1e34eb elementor-widget elementor-widget-heading"
                      data-id="d1e34eb"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Payment Card Industry Data Security Standard (PCI DSS)
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-23093b1 elementor-widget elementor-widget-text-editor"
                      data-id="23093b1"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          The global Payment Card Industry Data Security
                          Standard is required by businesses that allow card
                          payments as it secures the holder’s data
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
}
